import React, { Component } from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';

export default class DropzoneContainer extends Component {
  state = {
    dragClasses: null,
    counter: 0,
  };

  handleDragOver = e => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer.dropEffect === 'none') {
      e.dataTransfer.effectAllowed = 'none';
      e.dataTransfer.dropEffect = 'none';
    }
  };

  handleDragEnter(e) {
    if (e.dataTransfer && e.dataTransfer.types && e.dataTransfer.types.length) {
      // e.dataTransfer.dropEffect = 'none';
      const classes = ['dragging'];
      // For loop needed for IE11
      for (let i = 0; i < e.dataTransfer.types.length; i += 1) {
        classes.push(`dragging-${e.dataTransfer.types[i].toLowerCase()}`);
      }

      this.setState(state => ({
        counter: state.counter + 1,
        dragClasses: classes,
      }));
    } else {
      this.setState(state => ({
        dragClasses: null,
        counter: state.counter + 1,
      }));
    }
    e.preventDefault();
    e.stopPropagation();
  }

  handleDragLeave(e) {
    const { counter } = this.state;
    if (counter <= 1) {
      this.setState({
        dragClasses: null,
        counter: counter - 1,
      });
    } else {
      this.setState({
        counter: counter - 1,
      });
    }
    e.preventDefault();
    e.stopPropagation();
  }

  handleDrop() {
    this.setState({
      dragClasses: null,
      counter: 0,
    });
  }

  static propTypes = {
    children: PropTypes.element.isRequired,
    className: PropTypes.string,
  };

  static defaultProps = {
    className: '',
  };

  render() {
    const { className, children, ...passThroughProps } = this.props;
    const { dragClasses } = this.state;
    return (
      <div
        {...passThroughProps}
        onDragEnter={e => this.handleDragEnter(e)}
        onDragLeave={e => this.handleDragLeave(e)}
        onDragOver={e => this.handleDragOver(e)}
        onDrop={e => this.handleDrop(e)}
        className={classnames(className, dragClasses)}
      >
        {children}
      </div>
    );
  }
}
